// import IOwner from './IOwner';
// import Owner from './tract_detail/Owner';
// import WIContractOwnership from './tract_detail/WIContractOwnership'
import ContractAmendment from 'src/components/project/sections/LeasingComponents/redesign/ContractGenerationModels/ContractAmendment';
// import ContractClause from 'src/components/project/sections/LeasingComponents/redesign/ContractGenerationModels/ContractClause';
import ContractGenerationTractDetail from 'src/components/project/sections/LeasingComponents/redesign/ContractGenerationModels/ContractGenerationTractDetail';
import Acknowledgement from '../leasing/Acknowledgement';
import IOwner from 'src/models/IOwner';
import Owner from 'src/models/tract_detail/Owner';
import WIContractOwnership from 'src/models/tract_detail/WIContractOwnership';
import ContractAdHocClause from 'src/components/project/sections/LeasingComponents/redesign/ContractGenerationModels/ContractAdHocClause';
import ContractAddendumClauseXRef from 'src/components/project/sections/LeasingComponents/redesign/ContractGenerationModels/ContractAddendumClauseXRef';
import IContract from 'src/models/contract_types/IContract';
import ProvisionLeaseClause from '../ProvisionLeaseClause';

export default class SolarLease implements IContract {
    id: number;
    solarLeaseNumber?: number;
    solarLeaseName: string;
    lastName: string;
    firstName: string;
    companyName: string;
    akaName: string;
    spouseName: string;
    spouseAkaName: string;
    maritalStatus: string;
    lessorOnDocument: string;
    lessorSignatures: string;
    leaseLessorNotes: string;
    createdDate?: Date;
    createdByUserId?: number;
    grossAcres?: number;
    legalDescription: string;
    rteLegalDescription: string;
    terms?: number;
    termsTypeId?: number;
    optionDate?: Date;
    effectiveDate?: Date;
    bonusAmount?: number;
    bonusTypeId?: number;
    rentalAmount?: number;
    rentalTypeId?: number;
    rentalFrequencyId?: number;
    rentalTerms?: number;
    rentalTermTypeId?: number;
    rentDueDate?: Date;
    addlBonusDescription?: string;
    addlBonusAmount?: number;
    flatBonus?: number;
    reminderDate?: Date;
    reminderNumber?: string;
    commitDate?: Date;
    inHandDate?: Date;
    isCommitted?: boolean;
    isInHand?: boolean;
    voidDate?: Date;
    isVoid?: boolean;
    bankingDays?: number;
    bankingDaysUnit?: string;

    // new fields from the contract side
    clientDocNumber: string;
    leasedBy: string;
    reminderNote: string;
    lesseeName: string;
    lesseeAddressLine1: string;
    lesseeAddressLine2: string;
    lesseeCity: string;
    lesseeState: string;
    lesseeZipCode: string;
    lesseePhoneNumber: string;
    lesseeOwnerLookupId: number;
    isNotOriginalLessee: boolean;
    ownersOnDocument: string;
    ownersAddressOnDocument: string;
    ownersSSNTaxIdOnDocument: string;
    isAddConsideration?: boolean;
    addConsiderationAmount?: number;
    addConsiderationExplanation: string;
    isAddOptionToExtend?: boolean;
    addOptionTotalBonus?: number;
    addOptionBonusAmount?: number;
    addOptionTerm?: number;
    totalConsideration?: number;
    optionTotalBonus?: number;
    isGeneratedLease?: boolean;
    recordedDate?: Date;
    volume?: string;
    page?: string;
    instrumentNumber?: string;
    originalInHandDate?: Date;

    currentHold?: SolarLeaseHold;
    solarLeaseHolds?: Array<SolarLeaseHold>;

    // new fields to track
    fedStateLeaseNumber?: string;
    isFiledByMemo?: boolean;
    originalLessor: string;
    originalLessee: string;

    // not Mapped
    expirationDate?: Date;
    initialBonus?: number;
    rentTotal?: number;
    totalBonus?: number;
    tracts?: Array<ContractGenerationTractDetail>;
    acknowledgements?: Array<Acknowledgement>;
    amendments?: Array<ContractAmendment>;
    adHocClauses?: Array<ContractAdHocClause>;
    removeClauses?: Array<number>;
    contractClauses?: Array<ContractAddendumClauseXRef>;
    invoiceableLookupId?: number;
}

export class SolarLeaseHold {
    id: number;
    solarLeaseId?: number;
    number?: number;
    dueDiligenceEffectiveDate?: Date;
    dueDiligenceEffectiveTerm?: number;
    dueDiligenceEffectiveTermTypeId?: number;
    optionEffectiveDate?: Date;
    optionTerm?: number;
    optionTermTypeId?: number;
    constructionEffectiveDate?: Date;
    constructionTerm?: number;
    constructionTermTypeId?: number;
    operationEffectiveDate?: Date;
    operationTerm?: number;
    operationTermTypeId?: number;
    operationExtensionEffectiveDate?: Date;
    operationExtensionTerm?: number;
    operationExtensionTermTypeId?: number;
    dueDiligenceFee?: number;
    dueDiligenceFeeTypeId?: number;
    dueDiligenceExtensionFee?: number;
    dueDiligenceExtensionFeeTypeId?: number;
    constructionFee?: number;
    constructionFeeTypeId?: number;
    operatingIPFFee?: number;
    operatingIPFFeeTypeId?: number;
    operatingOPFFee?: number;
    operatingOPFFeeTypeId?: number;
    escalatingPct?: number;
    isActive?: boolean;
    isHistorical?: boolean;
    prepaidOption?: boolean;
    poolingOrderNumber?: string;
    hbp?: boolean;
    hbu?: boolean;
    operator?: string;
    wellName?: string;
    apiNumber?: string;
    unitName?: string;
    fieldName?: string;

    // new fields to track
    lessorAKA?: string;
    addlBonusDescription?: string;
    bonusTypeId?: number;
    rentalTypeId?: number;
    rentalTerms?: number;
    rentalTermTypeId?: number;
    rentalFrequencyId?: number;
    rentalAmount?: number;
    addlBonusAmount?: number;
    bonusAmount?: number;
    rentDueDate?: Date;
    decimalInterest?: number;
    ownershipId?: number;

    // not mapped
    dueDiligenceEffectiveExpirationDate?: Date;
    constructionExpirationDate?: Date;
    operationExpirationDate?: Date;
    operationExtensionExpirationDate?: Date;
    optionExpirationDate?: Date;
    wiOwners?: Array<Owner>;
    contractOwnerships?: Array<WIContractOwnership>;
    surfaceOwner: IOwner;
    contractLookupId?: number;
    dueDiligenceFeeTotal?: number;
    constructionFeeTotal?: number;
    operatingIPFFeeTotal?: number;
    operatingOPFFeeTotal?: number;
    dueDiligenceExtensionFeeTotal?: number;
    invoiceableLookupId?: number;
    provisionLeaseClauses?: Array<ProvisionLeaseClause>;
}



// WEBPACK FOOTER //
// ./src/models/contract_types/SolarLease.ts